import { AccessTimeOutlined, ArrowBackOutlined } from '@mui/icons-material';
import {
  Box, Button, Container, Divider, IconButton,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import Images from '../../../../Configs/images';
import { createSubscription } from '../../../../Redux/Models/subscription';
import { formatNum } from '../../../../Utils/helpers';
import { getUserData } from '../../../../Utils/storages';
import Elements from '../../../Elements';

// const NORMAL_PLAN = process.env.REACT_APP_SUBS_NORMAL;
// const PREMIUM_PLAN = process.env.REACT_APP_SUBS_PREMIUM;

export default function SubscriptionDetails({ classes, isLoading }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { subsType } = useParams();
  const userData = getUserData();
  const { subscriptions } = useSelector((state) => state.master);
  const [subscription, setSubscription] = useState({});

  useEffect(() => {
    if (!subsType) {
      navigate(-1);
    } else {
      const selected = subscriptions.filter((sub) => sub.id === subsType);
      if (selected.length) {
        setSubscription(selected[0]);
      }
    }
  }, [subsType]);

  const [subsConfirm, setSubsConfirm] = useState(false);
  const handleToggleSubsConfirm = () => {
    setSubsConfirm(!subsConfirm);
  };

  const handleSubscribe = () => {
    dispatch(createSubscription(subsType, userData.id));
  };

  return (
    <Elements.PageBase navigate={navigate} noNav>
      <div className={classes.root}>
        <div className="sticky head">
          <Container>
            <div className="flex align-items-center">
              <div>
                <IconButton sx={{ p: 0 }} onClick={() => navigate(-1)}>
                  <ArrowBackOutlined className="black" />
                </IconButton>
              </div>
              <div className="s-16 weight-700">Detail package</div>
            </div>
          </Container>
        </div>

        <Container>
          <Box className="package-box mt-2">
            <div className="regular" />
            <div className="detail-container">
              <div className="flex align-items-center">
                <img alt="star" src={subsType === 'premium' ? Images.PremiumStar : Images.NormalStar} />
                <div className="s-16 weight-700">
                  {subscription.name}
                </div>
              </div>

              <Box display="flex" alignItems="center" justifyContent="space-between" mt={3}>
                <Box display="flex" alignItems="center" gap={1}>
                  <AccessTimeOutlined fontSize="small" />
                  <div className="s-14 weight-700">
                    1 Month duration
                  </div>
                </Box>
                <Box display="flex" alignItems="center" gap={1}>
                  <img src={Images.Euro} alt="euro" width="20" />
                  <div className="s-14 weight-700">
                    {formatNum(Number(subscription.price?.unit_amount) / 100)}
                    .00
                  </div>
                </Box>
              </Box>

              {/* <div className="s-12 mute mt-3">Package details</div> */}
              <div className="mt-3 height-16 s-14">
                {subscription.description}
              </div>

              <Divider sx={{ my: 2 }} />

              <div className="s-14 weight-600">Package benefits</div>
              <div>
                {subscription.package_benefit?.map((benefit) => (
                  <li className="mt-2 s-14 weight-400" key={benefit}>{benefit}</li>
                ))}
              </div>

              <Divider sx={{ my: 2 }} />

              <div className="s-14 weight-600">Terms and conditions</div>
              <div>
                {subscription.terms_and_conditions?.map((condition) => (
                  <li className="mt-2 s-14 weight-400" key={condition}>{condition}</li>
                ))}
              </div>

            </div>
          </Box>
        </Container>

        <div className="floating-action">
          <Container>
            <Button className="btn-contained" fullWidth onClick={handleToggleSubsConfirm}>Subscribe now</Button>
          </Container>
        </div>
      </div>

      <Elements.ConfirmationModal
        open={subsConfirm}
        desc={(
          <div className="s-16 height-14 weight-700 center">
            Confirm to subscribe
            <br />
            Normal package?
          </div>
        )}
        handleClose={handleToggleSubsConfirm}
        handleAgree={handleSubscribe}
        isLoading={isLoading}
      />
    </Elements.PageBase>
  );
}
